





















import { Component, Mixins } from 'vue-property-decorator'
import BasePage from '@/tcw/components/BasePage'
import TcwLayoutBasicTemplate from '@/layout/TcwLayoutBasicTemplate.vue'
import UserSetteiForm from '@/components/settei/organisms/UserSetteiForm.vue'
import FormStoreComponent from '@/tcw/components/FormStoreComponent'

@Component({
  components: { TcwLayoutBasicTemplate, UserSetteiForm }
})
export default class UserSetteiPage extends Mixins(BasePage) {
  protected get form(): FormStoreComponent {
    return this.$refs.form as FormStoreComponent
  }

  protected async save(): Promise<void> {
    this.form.startSaveProc()
  }
}
